export default "__VITE_ASSET__Cet_bqsK__"